import { ClientOnly, createFileRoute } from "@tanstack/react-router";

import { noIndexSeo } from "@/lib/seo";

import { NarratorCanvas } from "./-components/narrator-canvas";

export const Route = createFileRoute("/(app)/narrator/$sessionId")({
	component: NarratorPage,
	head: ({ match }) =>
		noIndexSeo({
			title: "Narrator | StudyOS",
			description: "Generate and review narrated study content in your StudyOS workspace.",
			pathname: match.pathname,
		}),
});

function NarratorPage() {
	const { sessionId } = Route.useParams();

	return (
		<ClientOnly>
			<NarratorCanvas sessionId={sessionId} />
		</ClientOnly>
	);
}
